var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDayW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 41,
    viewBox: "0 0 38 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_736_64)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 4.5,
    width: 35,
    height: 35,
    rx: 5.5,
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 1.8125V7.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3125 1.8125V7.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.404785 14.875H37.192",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22553 29.724C7.82353 29.724 7.47253 29.652 7.17253 29.508C6.87853 29.358 6.62653 29.151 6.41653 28.887L7.36153 27.978C7.46953 28.128 7.59553 28.242 7.73953 28.32C7.88953 28.398 8.05753 28.437 8.24353 28.437C8.42353 28.437 8.57953 28.401 8.71153 28.329C8.84353 28.251 8.94853 28.143 9.02653 28.005C9.10453 27.861 9.14353 27.684 9.14353 27.474V23.271H10.5655V27.393C10.5655 27.867 10.4695 28.278 10.2775 28.626C10.0855 28.974 9.81553 29.244 9.46753 29.436C9.11953 29.628 8.70553 29.724 8.22553 29.724ZM14.7256 29.733C14.2456 29.733 13.8016 29.649 13.3936 29.481C12.9916 29.313 12.6376 29.079 12.3316 28.779C12.0256 28.479 11.7886 28.131 11.6206 27.735C11.4526 27.333 11.3686 26.901 11.3686 26.439C11.3686 25.971 11.4526 25.539 11.6206 25.143C11.7886 24.747 12.0226 24.402 12.3226 24.108C12.6226 23.808 12.9736 23.577 13.3756 23.415C13.7836 23.247 14.2276 23.163 14.7076 23.163C15.1816 23.163 15.6196 23.247 16.0216 23.415C16.4296 23.577 16.7836 23.808 17.0836 24.108C17.3896 24.402 17.6266 24.75 17.7946 25.152C17.9626 25.548 18.0466 25.98 18.0466 26.448C18.0466 26.91 17.9626 27.342 17.7946 27.744C17.6266 28.14 17.3926 28.488 17.0926 28.788C16.7926 29.082 16.4386 29.313 16.0306 29.481C15.6286 29.649 15.1936 29.733 14.7256 29.733ZM14.7076 28.446C15.0856 28.446 15.4156 28.362 15.6976 28.194C15.9856 28.026 16.2076 27.792 16.3636 27.492C16.5196 27.186 16.5976 26.835 16.5976 26.439C16.5976 26.139 16.5526 25.869 16.4626 25.629C16.3726 25.383 16.2436 25.173 16.0756 24.999C15.9076 24.819 15.7066 24.684 15.4726 24.594C15.2446 24.498 14.9896 24.45 14.7076 24.45C14.3296 24.45 13.9966 24.534 13.7086 24.702C13.4266 24.864 13.2076 25.095 13.0516 25.395C12.8956 25.689 12.8176 26.037 12.8176 26.439C12.8176 26.739 12.8626 27.012 12.9526 27.258C13.0426 27.504 13.1686 27.717 13.3306 27.897C13.4986 28.071 13.6996 28.206 13.9336 28.302C14.1676 28.398 14.4256 28.446 14.7076 28.446ZM21.4995 29.724C20.9775 29.724 20.5155 29.613 20.1135 29.391C19.7175 29.169 19.4055 28.863 19.1775 28.473C18.9555 28.077 18.8445 27.627 18.8445 27.123V23.271H20.2665V27.204C20.2665 27.456 20.3205 27.675 20.4285 27.861C20.5365 28.047 20.6835 28.191 20.8695 28.293C21.0615 28.389 21.2715 28.437 21.4995 28.437C21.7395 28.437 21.9495 28.389 22.1295 28.293C22.3095 28.191 22.4505 28.05 22.5525 27.87C22.6605 27.684 22.7145 27.465 22.7145 27.213V23.271H24.1365V27.132C24.1365 27.636 24.0255 28.083 23.8035 28.473C23.5815 28.863 23.2725 29.169 22.8765 29.391C22.4805 29.613 22.0215 29.724 21.4995 29.724ZM26.3429 27.006V25.962H27.6839C27.9659 25.962 28.1819 25.89 28.3319 25.746C28.4879 25.602 28.5659 25.407 28.5659 25.161C28.5659 24.933 28.4909 24.744 28.3409 24.594C28.1909 24.444 27.9749 24.369 27.6929 24.369H26.3429V23.271H27.8549C28.2749 23.271 28.6439 23.352 28.9619 23.514C29.2799 23.67 29.5289 23.889 29.7089 24.171C29.8889 24.453 29.9789 24.777 29.9789 25.143C29.9789 25.515 29.8889 25.842 29.7089 26.124C29.5289 26.4 29.2769 26.616 28.9529 26.772C28.6289 26.928 28.2479 27.006 27.8099 27.006H26.3429ZM25.2629 29.625V23.271H26.6759V29.625H25.2629ZM28.7189 29.625L26.7389 26.889L28.0349 26.538L30.3929 29.625H28.7189Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_736_64",
    x: -4,
    y: -3.1875,
    width: 46,
    height: 48.1875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_736_64"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_736_64",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayW);
export default __webpack_public_path__ + "static/media/dayW.22924c0d5469a1e47dfa0ed627c42da3.svg";
export { ForwardRef as ReactComponent };